import { cn } from '../../lib/utils'

// Ni jaune (action), ni vert ou rouge (statuts) : la couleur d'un avatar ne signifie rien
const TEINTES = ['bg-blue-100 text-blue-900', 'bg-indigo-100 text-indigo-900', 'bg-sky-100 text-sky-900', 'bg-slate-200 text-slate-900', 'bg-violet-100 text-violet-900']

const initiales = (nom: string) => {
  const mots = nom.trim().split(/\s+/).filter(Boolean)
  return ((mots[0]?.[0] ?? '?') + (mots.length > 1 ? (mots[mots.length - 1]![0] ?? '') : (mots[0]?.[1] ?? ''))).toUpperCase()
}

/** Pastille d'initiales, teinte stable pour un même nom. */
export function Avatar({ nom, className }: { nom: string; className?: string }) {
  const teinte = TEINTES[[...nom].reduce((n, c) => n + c.charCodeAt(0), 0) % TEINTES.length]
  return (
    <span aria-hidden className={cn('flex size-12 shrink-0 items-center justify-center rounded-full text-lg font-bold', teinte, className)}>
      {initiales(nom)}
    </span>
  )
}
